import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Pie } from 'react-chartjs-2';
import { Skeleton } from '@material-ui/lab';
import MuiAlert from '@material-ui/lab/Alert';
import { Divider, Backdrop, CircularProgress, Snackbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { Context } from "../contexts/siteContext.js";
import { Theme } from "../contexts/themeContext.js";
import { GlobalTheme, TileTheme } from "../../layouts/theme";
import Card from "../card/card.js";
import CardHeader from "../card/cardHeader.js";
import CardBody from "../card/cardBody.js";
import CardContent from '@material-ui/core/CardContent';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
        position: "absolute"
    }
}));

export default function TeamCoachChart(props) {
    const classes = useStyles();
    const tileClasses = TileTheme();
    const offlineService = new OfflineService();
    const { defaultSite, siteLoading } = useContext(Context);
    const { theme } = useContext(Theme);
    const [loading, setLoading] = useState(true);
    const [backDrop, setBackDrop] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [totalInspections, setTotalInspections] = useState(0);
    const [totalSurveys, setTotalSurveys] = useState(0)
    const [totalObservations, setTotalObservations] = useState(0);
    const [avgScore, setAvgScore] = useState(0);
    const currentTheme = GlobalTheme[theme];
    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const linkClicked = (e) => {
        if (defaultSite.IntegratedSystem.TeamCoachId === null || defaultSite.IntegratedSystem.TeamCoachId === "0") {
            e.preventDefault();
            setErrorMessage("The Site " + defaultSite.name + " has not been setup to access TeamCoach.");
            setOpenError(true);
        }
    };

    const getCoachSummary = () => {
        setBackDrop(true);
        HttpService.post("/TeamCoach/GetCoachSummary", {
            HouseCode: defaultSite.houseCode[0],
            SiteId: defaultSite.id
        })
        .then(async (result) => {
            if (result && result.offline) {
                let offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "CoachSummary");
                result = offlineResult.OfflineData;
            }
            else {
                offlineService.removeOfflineBySite(defaultSite.id, "CoachSummary");
                offlineService.addOffline(defaultSite.id, "CoachSummary", result);
            }

            if (result.data !== null) {
                setTotalInspections(result.data.Inspections);
                setTotalSurveys(result.data.Surveys);
                setTotalObservations(result.data.Observations);
                setAvgScore(result.data.AvgScore * 100);
            }
            setLoading(false);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const chartData = {
        datasets: [{
            data: [avgScore, 100 - avgScore],
            backgroundColor: ['#0066CC', '#99CCFF']
        }]
    };

    const options = {
        tooltips: {
            enabled: avgScore > 0,
            callbacks: {
                label: function (tooltipItem, data) {
                    if (tooltipItem.index === 0)
                        return data['datasets'][0]['data'][tooltipItem['index']].toString() + ' %';
                }
            }
        }
    };

    useEffect(() => {
        if (!siteLoading)
            getCoachSummary();
        //eslint-disable-next-line 
    }, [props.mode, defaultSite, siteLoading]);

    return (<>
        <div style={{ position: "relative" }}>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Link to={{ pathname: "/TeamCoachList" }} onClick={(e) => linkClicked(e)}>
                <Backdrop className={classes.backdrop} id="teamCoachBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Card chart color="primary" className={tileClasses.card } style={{ background: currentTheme.background, color: currentTheme.text }} >
                    <CardContent className={tileClasses.cardContent}>
                        <CardHeader>
                            <div className={tileClasses.title}>TeamCoach</div>
                            {loading === true ? (<Skeleton variant="rect" height={76} />) : (
                                <Pie data={chartData} options={options} height={76} />
                            )}
                        </CardHeader>
                        <Divider />
                        <CardBody>
                            <div className={tileClasses.subTitle}>Weekly Summary</div>
                            {loading === true ? (<div><Skeleton variant="text" /><Skeleton variant="text" /></div>) : (
                                <div className="d-flex flex-column">
                                    <label className={tileClasses.optionText}>Inspections: {totalInspections}</label>
                                    <label className={tileClasses.optionText}>Surveys: {totalSurveys}</label>
                                    <label className={tileClasses.optionText}>Observations: {totalObservations}</label>
                                </div>
                            )}
                        </CardBody>
                    </CardContent>
                </Card>
            </Link>
        </div>
    </>
    );
}
